import type { ControlAction } from './types';

export type TouchDirection = 'forward' | 'backward' | 'left' | 'right' | 'ascend' | 'descend';

export class TouchInput {
  private readonly held = new Map<number, TouchDirection>();
  private actions: ControlAction[] = [];
  private enabled = true;
  private boost = false;

  hold(pointer: number, direction: TouchDirection): void {
    if (this.enabled) this.held.set(pointer, direction);
  }

  release(pointer: number): void {
    this.held.delete(pointer);
  }

  toggleBoost(): void {
    if (this.enabled) this.boost = !this.boost;
  }

  perform(action: ControlAction): void {
    if (this.enabled) this.actions.push(action);
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) this.clear();
  }

  clear(): void {
    this.held.clear();
    this.actions = [];
    this.boost = false;
  }

  isHeld(direction: TouchDirection): boolean {
    return [...this.held.values()].includes(direction);
  }

  get boosted(): boolean {
    return this.boost;
  }

  poll() {
    const axis = (positive: TouchDirection, negative: TouchDirection): number =>
      Number(this.isHeld(positive)) - Number(this.isHeld(negative));
    const actions = this.actions;
    this.actions = [];
    return {
      forward: axis('forward', 'backward'),
      right: axis('right', 'left'),
      up: axis('ascend', 'descend'),
      boost: this.boost,
      actions,
    };
  }
}
